module.exports = __webpack_public_path__ + "img/iconscuola.7947da50.svg";